var _rect, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInscriptionIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 350",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e3a5f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2d5a8e",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 300,
    height: 350,
    fill: "url(#bgGradient)",
    rx: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 80,
    r: 60,
    fill: "#1a3250",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 35,
    fill: "#d32f2f",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 25,
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 5,
    x2: 25,
    y2: 30,
    stroke: "#d32f2f",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(210, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 40,
    fill: "#1976d2",
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 10,
    x2: 25,
    y2: 10,
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 17,
    x2: 25,
    y2: 17,
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 24,
    x2: 20,
    y2: 24,
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 40,
    fill: "#42a5f5",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 30,
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 5,
    x2: 30,
    y2: 35,
    stroke: "#42a5f5",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 230)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 50,
    fill: "#fff",
    rx: 2,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 15,
    x2: 60,
    y2: 15,
    stroke: "#1976d2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 25,
    x2: 60,
    y2: 25,
    stroke: "#1976d2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 35,
    x2: 50,
    y2: 35,
    stroke: "#1976d2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -5,
    width: 70,
    height: 50,
    fill: "#fff",
    rx: 2,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -10,
    width: 70,
    height: 50,
    fill: "#e3f2fd",
    rx: 2,
    opacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 55,
    height: 45,
    fill: "#ff6f00",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 45,
    height: 35,
    fill: "#e65100"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    y1: 5,
    x2: 27.5,
    y2: 40,
    stroke: "#ff6f00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 10,
    x2: 58,
    y2: 10,
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 15,
    x2: 58,
    y2: 15,
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 20,
    x2: 58,
    y2: 20,
    stroke: "#fff",
    strokeWidth: 1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 65,
    height: 50,
    fill: "#c62828",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 55,
    height: 40,
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 5,
    x2: 32.5,
    y2: 45,
    stroke: "#c62828",
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 230)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 60,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 15,
    x2: 37,
    y2: 15,
    stroke: "#1976d2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 25,
    x2: 37,
    y2: 25,
    stroke: "#1976d2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 35,
    x2: 32,
    y2: 35,
    stroke: "#1976d2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 45,
    x2: 37,
    y2: 45,
    stroke: "#1976d2",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInscriptionIllustration);
export default __webpack_public_path__ + "static/media/inscription-illustration.e5869ff94492c6573f7b64f4a7401dd5.svg";
export { ForwardRef as ReactComponent };